import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import oauth from './oauth'
import calculator from './calculator'
import pusher from './pusher'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    oauth,
    calculator,
    pusher,
  },
  strict: process.env.DEV,
})
